import Banner from '@/components/Banner2';
import SpeechCase from '@/components/SpeechCase';
import Title from '@/components/Title';
import BusiCard from '@/components/BusiCard';
import Advantages2 from '@/components/Advantages2';
import Appointment2 from '@/components/Appointment2/index.vue';
import { mixin } from './mixins';
import { imageUrl, bannerText, adsListLeft, adsListRight, casesList, applicationsList } from './config';
export default {
  mixins: [mixin],
  components: {
    Banner,
    SpeechCase,
    Title,
    BusiCard,
    Advantages2,
    Appointment2
  },
  data() {
    return {
      imageUrl,
      bannerText,
      adsListLeft,
      adsListRight,
      casesList,
      applicationsList
    };
  }
};